import { render, staticRenderFns } from "./ordersLifes.vue?vue&type=template&id=656a9a92&scoped=true&"
import script from "./ordersLifes.vue?vue&type=script&lang=js&"
export * from "./ordersLifes.vue?vue&type=script&lang=js&"
import style0 from "./ordersLifes.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ordersLifes.vue?vue&type=style&index=1&id=656a9a92&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a9a92",
  null
  
)

component.options.__file = "ordersLifes.vue"
export default component.exports